import React from "react";
import { Text, TextArea, Switch } from "components/fields";
import config from "constants/config";


export default ({ form, onChange, isUtils }) => {

	const { warranty } = form.values;

	const onChangeData = (e) => {
		form.handleChange("warranty")(e.target.value);

		if(onChange) {
			onChange(e.target.value);
		}
	}

	return <>

		{isUtils ? null : <Switch {...form} label="Warranty" name="warranty_enabled" note="Specify a warranty for your product, this way buyers will not be able to leave a bad feedback if they do not contact you within the warranty delay." left
								  withBorder={form.values.warranty_enabled ? false : true}
		/>}

		{form.values.warranty_enabled || isUtils ?
			<div className={`warranty-field ${isUtils ? '' : 'mb-3'}`} style={{ borderBottom: isUtils ? "" : "1px solid var(--black1)" }}>

				<div className="mb-4">
					{isUtils ? <div className="paylixecommerce-label">Warranty</div> : null}
					<select name="warranty" value={warranty} className="paylixecommerce-select" onChange={onChangeData}>
						{config.WARRANTY_OPTIONS.map(({value, label}) => <option key={value} value={value}>{label}</option>)}
					</select>
				</div>

				{warranty === "1" && <div className="d-flex flex-column justify-content-end">
					<Text name="manuallyWarranty" type="number" placeholder="Value in seconds" {...form} />
				</div>}

				{!!+warranty && <TextArea name="warranty_text" placeholder="Warranty text" {...form} />}
			</div>

			: null
		}

	</>
}